import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { cl_api, cl_setAccessToken } from '@/api';

interface ClUser { id: string; email: string; displayName: string; role: 'PARENT' | 'ADMIN'; }

export const useAuthStore = defineStore('cl_auth', () => {
  const cl_user = ref<ClUser | null>(null);
  const cl_ready = ref(false);
  const cl_authenticated = computed(() => Boolean(cl_user.value));

  async function cl_restore() {
    try {
      const cl_session = await cl_api.post('/auth/refresh');
      cl_setAccessToken(cl_session.data.cl_accessToken);
      cl_user.value = (await cl_api.get('/auth/me')).data;
    } catch { cl_user.value = null; }
    finally { cl_ready.value = true; }
  }

  async function cl_login(cl_email: string, cl_password: string) {
    const cl_session = await cl_api.post('/auth/login', { cl_email, cl_password });
    cl_setAccessToken(cl_session.data.cl_accessToken);
    cl_user.value = (await cl_api.get('/auth/me')).data;
  }

  async function cl_register(cl_email: string, cl_password: string, cl_displayName: string) {
    const cl_session = await cl_api.post('/auth/register', { cl_email, cl_password, cl_displayName });
    cl_setAccessToken(cl_session.data.cl_accessToken);
    cl_user.value = (await cl_api.get('/auth/me')).data;
  }

  async function cl_logout() {
    await cl_api.post('/auth/logout');
    cl_setAccessToken(''); cl_user.value = null;
  }

  return { cl_user, cl_ready, cl_authenticated, cl_restore, cl_login, cl_register, cl_logout };
});
